import { render, staticRenderFns } from "./XueYangChart.vue?vue&type=template&id=bd5aff2e&scoped=true&"
import script from "./XueYangChart.vue?vue&type=script&lang=js&"
export * from "./XueYangChart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd5aff2e",
  null
  
)

export default component.exports